import { CPRequestDetail } from "../../../api/models/unified";
import { useGetCodebooksQuery } from "../../../common/queries";
import { Box } from "../../../components";
import { IBoxItem } from "../../../components/box/BoxItem";
import { oneLineAddress } from "../../../helpers/addressesHelpers";
import { renderDate } from "../../../helpers/dayjsHeleprs";
import { useNavigate } from "../../../helpers/navigationHelpers";
import { useCustomTranslation } from "../../../helpers/translateHelpers";

interface RequestInfoBoxProps {
  detail: CPRequestDetail;
}

const RequestInfoBox = ({ detail }: RequestInfoBoxProps) => {
  const { tRequest } = useCustomTranslation();

  const codebooks = useGetCodebooksQuery();
  const navigate = useNavigate();

  const linkedOrders: IBoxItem[] = detail.orders.map((order) => ({
    label: tRequest("linked_order"),
    value: order.code,
    subLabel: order.name,
    onClick: () => navigate.goTo(`orders/${order.id}`),
  }));

  return (
    <Box
      title=""
      cols={2}
      items={[
        {
          label: tRequest("type"),
          value: tRequest(`type_${detail.type}`),
        },
        {
          label: tRequest("service_object_operator"),
          value: detail.endCustomerName as string | undefined,
          hidden: detail.type !== "OrderRequestFromOwner",
        },
        {
          label: tRequest("requested_date"),
          value: detail.requestedDate && renderDate(detail.requestedDate),
          hidden: detail.type !== "OrderRequest",
        },
        {
          label: tRequest("category"),
          value: codebooks.data?.orderRequestCategories.find(
            (x) => x.id === detail.categoryId,
          )?.name,
          hidden: detail.type !== "OrderRequest",
        },
        {
          label: tRequest("address"),
          value: oneLineAddress(detail),
          hidden: detail.type !== "OrderRequest",
        },
        {
          label: tRequest("contact_person"),
          value: `${detail.firstName} ${detail.lastName}`,
          hidden: detail.type !== "OrderRequest",
        },
        {
          label: tRequest("service_object"),
          value: detail.serviceObjects.map((x) => x.name).join(", "),
          hidden:
            detail.type !== "ServiceObjectUpdate" &&
            detail.type !== "OrderRequest",
        },
        ...linkedOrders,
      ]}
    />
  );
};

export default RequestInfoBox;
